loader();

function loader() {
    // // console.log('V01');
    "use strict";
    var $ = require('jquery');
    var bodymovin = require('bodymovin');
    // ebug('loader');
    $('.preloader').each(function() {
        var figure1 = this;
        var canim1 = {
            container: this,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: themeURL + 'js/loader.json'
        };
        var anim = bodymovin.loadAnimation(canim1);
        anim.addEventListener('DOMLoaded', function(e) {
            // anim.playSegments([0, 45], true);
            // anim.playSegments([46, 98], false);
        });
    });
    // $('.preloader_container').fadeOut(5000);
    $('.error404').each(function() {
        var figure1 = this;
        var canim1 = {
            container: this,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: themeURL + 'assets/json/404.json'
        };
        var anim = bodymovin.loadAnimation(canim1);
        anim.addEventListener('DOMLoaded', function(e) {
            anim.playSegments([0, 48], true);
            anim.playSegments([24, 50], false);
        });
    });
}

$(document).ready(function() {
    // setTimeout(() => {
    //     $('.preloader-container').fadeOut(500);
    // }, 2000);
    // setTimeout(function() {
    $('.preloader-container').fadeOut();
    $('.trigger').click();
    // $('.sidefixed').click();
    // }, 3000)
});